// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"75fda2f0","206":"6f8fc8b7","208":"1fe43fa2","450":"49a7f7e1","453":"5eabfba2","620":"402c2103","771":"7a7e8453","935":"554ccf6e"}[chunkId] + ".chunk.js";
};